import notificationsSlice from "./NotificationsSlice";
import diarySlice from "./diarySlice";
import dietPlanSlice from "./dietPlanSlice";
import homeGroupSlice from "./homeGroupsSlice";
import initialConfigSlice from "./initialConfigSlice";
import profileSettingsSlice from "./profileSettingsSlice";
import pushSettingsSlice from "./pushSettingsSlice";
import toastSlice from "./toastSlice";
import userSlice from "./userSlice";
import courseSlice from "./courseSlice";
import groupSlice from "./groupSlice";
import groupsSlice from "./groupsSlice";
import multimediaGroupsSlice from "./multimediaGroupsSlice";
import menuDaySlice from "./menuDaySlice";
import pushMuteSlice from "./pushMuteSlice";
import protocolSelectionSlice from "./protocolSelectionSlice";
import homeSlice from "./homeSlice";
import social from "./socialSlice";
import streamChatSlice from "./streamChatReducer";
import chatUnreadSlice from "./chatUnreadSlice";
import coinsSlice from "./coinsSlice";
import preLoginReducer from "./preLoginSlice";
import profilePushNotificationsSlice from "./profilePushNotificationsSlice";
import preRegisterReducer from "./preRegisterSlice";
import recipeSlice from "./recipeSlice";
import mioPercorsoSlice from "./mioPercorsoSlice";
import primaDopoSlice from "./primaDopoSlice";
import streamingSlice from "./streamingSlice";
import undesirableFoodsSlice from "./undesirableFoodsSlice";
import challengesSlice from "./challengesSlice";
import videosSlice from "./videosSlice";
import permissionsSlice from "./permissionsSlice";
import communitySortOrderSlice from "./communitySortOrderSlice";
import commentsSheetSlice from "./commentsSheetSlice";
import storiesSlice from "./storiesSlice";

const rootReducer = {
  user: userSlice,
  diary: diarySlice,
  recipes: recipeSlice,
  preLogin: preLoginReducer,
  mioPercorso: mioPercorsoSlice,
  primaDopo: primaDopoSlice,
  preRegister: preRegisterReducer,
  home: homeSlice,
  toast: toastSlice,
  course: courseSlice,
  group: groupSlice,
  social,
  groups: groupsSlice,
  dietPlan: dietPlanSlice,
  pushMute: pushMuteSlice,
  homeGroup: homeGroupSlice,
  pushSettings: pushSettingsSlice,
  notifications: notificationsSlice,
  initialConfig: initialConfigSlice,
  profileSettings: profileSettingsSlice,
  profilePushNotifications: profilePushNotificationsSlice,
  multimediaGroups: multimediaGroupsSlice,
  menuDay: menuDaySlice,
  protocolSelection: protocolSelectionSlice,
  streamChat: streamChatSlice,
  chatUnread: chatUnreadSlice,
  coins: coinsSlice,
  streaming: streamingSlice,
  undesirableFoods: undesirableFoodsSlice,
  challenges: challengesSlice,
  videos: videosSlice,
  permissions: permissionsSlice,
  communitySortOrder: communitySortOrderSlice,
  commentsSheet: commentsSheetSlice,
  stories: storiesSlice,
};

export default rootReducer;
